/* rt-nav-center:v1 (2026-10-21, Mikey: "center the top bar over the bottom bar"; v1 also aligns MUSIC with the hero).
   The partner row and the tab row are ONE wrapping ul, so CSS cannot centre one line on another.
   Measure both lines and give the first partner li the margin that centres the partner row over the tab row. */
(function () {
  var ul, busy = false;
  function fit() {
    if (busy) return; busy = true;
    try {
      ul = ul || document.querySelector('.header__inline-menu > ul.list-menu--inline');
      if (!ul) return;
      var kids = Array.prototype.slice.call(ul.children);
      var brk = kids.filter(function (l) { return l.classList.contains('rt-nav-break') && !l.classList.contains('rt-nav-break--services'); })[0];
      if (!brk) return;
      var idx = kids.indexOf(brk);
      var tabs = kids.slice(0, idx).filter(function (l) { return !l.classList.contains('rt-nav-break'); });
      var partners = kids.slice(idx + 1).filter(function (l) { return !l.classList.contains('rt-nav-break'); });
      if (!tabs.length || !partners.length) return;
      var first = partners[0];
      first.style.removeProperty('margin-left');
      ul.style.removeProperty('margin-left'); ul.style.removeProperty('width');
      if (window.innerWidth < 990) return;
      /* rt-nav-align:v1 (2026-10-21, Mikey: "move them right slightly so MUSIC lines up with the dig hero"):
         shift both rows so the MUSIC label starts on the left edge of #MainContent (the hero) */
      var main = document.getElementById('MainContent');
      if (main) {
        var padL = parseFloat(getComputedStyle(tabs[0]).paddingLeft) || 0;
        var sh = main.getBoundingClientRect().left - (tabs[0].getBoundingClientRect().left + padL);
        if (sh > 0 && sh < 120) {
          ul.style.setProperty('margin-left', sh.toFixed(1) + 'px', 'important');
          ul.style.setProperty('width', 'calc(100% - ' + sh.toFixed(1) + 'px)', 'important');
        }
      }
      var tl = tabs[0].getBoundingClientRect().left, tr = tabs[tabs.length - 1].getBoundingClientRect().right;
      var pl = first.getBoundingClientRect().left, pr = partners[partners.length - 1].getBoundingClientRect().right;
      if (tl > pl + 1 || !(tr > tl)) return; /* different layout (mobile / wrapped): leave alone */
      var off = ((tr - tl) - (pr - pl)) / 2;
      if (off <= 0) return;
      var z = parseFloat(getComputedStyle(first).zoom) || 1;
      first.style.setProperty('margin-left', (off / z).toFixed(1) + 'px', 'important');
    } finally { busy = false; }
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(fit, 30); }
  window.addEventListener('resize', soon);
  window.addEventListener('load', soon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(soon);
  document.addEventListener('DOMContentLoaded', soon);
  setTimeout(soon, 600); setTimeout(soon, 2000);
})();
